// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3M7WO","disabled":"FileBtn_disabled__11WVH","warn":"FileBtn_warn__2oMMK","fade":"FileBtn_fade__2Az1S"};